export const readEnvMs = (key: string, fallback: number): number => {
  const raw = process.env[key];
  if (raw == null || raw.trim() === "") {
    return fallback;
  }
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const autoRefresh = {
  dashboard: {
    SESSION_SUMMARY: readEnvMs("REACT_APP_AUTO_REFRESH_DASHBOARD_SESSION_SUMMARY_MS", 10000),
    CHARGING_STATION: readEnvMs("REACT_APP_AUTO_REFRESH_DASHBOARD_CHARGING_STATION_MS", 300000),
    FEE_COLLECTED: readEnvMs("REACT_APP_AUTO_REFRESH_DASHBOARD_FEE_COLLECTED_MS", 15 * 60 * 1000),
    ENERGY_USAGE: readEnvMs("REACT_APP_AUTO_REFRESH_DASHBOARD_ENERGY_USAGE_MS", 15 * 60 * 1000),
    CONNECTORS: readEnvMs("REACT_APP_AUTO_REFRESH_DASHBOARD_CONNECTORS_MS", 300000),
    TOTAL_SESSIONS: readEnvMs("REACT_APP_AUTO_REFRESH_DASHBOARD_TOTAL_SESSIONS_MS", 10000),
    TELEMATICS_API_CALL_INTERVAL: readEnvMs("REACT_APP_AUTO_REFRESH_DASHBOARD_TELEMATICS_MS", 300000),
  },
  chargingStation: {
    GET_SITES: readEnvMs("REACT_APP_AUTO_REFRESH_CHARGING_STATION_GET_SITES_MS", 3600000),
    CHARGING_STATION: readEnvMs("REACT_APP_AUTO_REFRESH_CHARGING_STATION_MS", 10000),
    ROW_COUNT: readEnvMs("REACT_APP_AUTO_REFRESH_CHARGING_STATION_ROW_COUNT_MS", 3600000),
    TOTAL_CAPACITY: readEnvMs("REACT_APP_AUTO_REFRESH_CHARGING_STATION_TOTAL_CAPACITY_MS", 10000),
    CONNECTORS: readEnvMs("REACT_APP_AUTO_REFRESH_CHARGING_STATION_CONNECTORS_MS", 300000),
  },
  gridify: {
    DEMAND_VIEW_SUMMARY: readEnvMs("REACT_APP_AUTO_REFRESH_GRIDIFY_DEMAND_VIEW_SUMMARY_MS", 10000),
    DEMAND_VIEW_DATA: readEnvMs("REACT_APP_AUTO_REFRESH_GRIDIFY_DEMAND_VIEW_DATA_MS", 10000),
    DEMAND_VIEW_GRAPH: readEnvMs("REACT_APP_AUTO_REFRESH_GRIDIFY_DEMAND_VIEW_GRAPH_MS", 10000),
    POWER_LOGIC: readEnvMs("REACT_APP_AUTO_REFRESH_GRIDIFY_POWER_LOGIC_MS", 10000),
  },
  sessions: {
    IN_PROGRESS: readEnvMs("REACT_APP_AUTO_REFRESH_SESSIONS_IN_PROGRESS_MS", 10000),
    IN_HISTORY: readEnvMs("REACT_APP_AUTO_REFRESH_SESSIONS_IN_HISTORY_MS", 60000),
  },
  rfid: {
    SUMMARY: readEnvMs("REACT_APP_AUTO_REFRESH_RFID_SUMMARY_MS", 300000),
  },
  DEFAULT: readEnvMs("REACT_APP_AUTO_REFRESH_DEFAULT_MS", 10000),
};
